const Home = () => (
  <div className="main-content">
    <h1>Welcome to our page!</h1>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Odit, facilis
      excepturi. Accusantium nulla cupiditate voluptatem sapiente aliquid illo
      eum repellendus in quia modi laboriosam vel aperiam fugiat, sequi omnis
      hic.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur harum
      itaque ipsam perspiciatis, asperiores, magnam ex, qui temporibus dolorum
      nisi sequi sunt illo. Quidem libero vitae debitis laborum quod! Itaque.
    </p>
  </div>
);
export default Home;
